import {Component, Input} from '@angular/core';
import {StatisticsItem} from "../../interfaces/statistics-item";

@Component({
  selector: 'brt-statistics-item',
  templateUrl: './statistics-item.component.html',
  styleUrls: ['./statistics-item.component.scss']
})
export class StatisticsItemComponent {

  @Input('data') set setData(val: StatisticsItem) {
    this.data = val;

    if(this.data.imageAspectRatio !== undefined) {
      this.aspectRatio = this.data.imageAspectRatio;
    }
  }

  data!: StatisticsItem;

  aspectRatio: string = "";

  onItemClicked() {
    if(this.data.link) {
      window.open(this.data.link, "_blank");
    }
  }

  onImageLoaded($event: void) {

  }
}
